var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.368,29.292h-7.66H31.292h-7.66c-1.104,0-2,0.896-2,2v33.416c0,1.104,0.896,2,2,2h7.66h33.416h7.66c1.104,0,2-0.896,2-2 V31.292C74.368,30.188,73.473,29.292,72.368,29.292z M66.708,46.658h3.66v2.684h-3.66V46.658z M66.708,42.658v-2.683h3.66v2.683 H66.708z M66.708,53.342h3.66v2.683h-3.66V53.342z M70.368,35.975h-3.66v-2.683h3.66V35.975z M29.292,49.342h-3.66v-2.684h3.66 V49.342z M29.292,42.658h-3.66v-2.683h3.66V42.658z M25.632,53.342h3.66v2.683h-3.66V53.342z M29.292,33.292v2.683h-3.66v-2.683 H29.292z M25.632,60.024h3.66v2.684h-3.66V60.024z M33.292,33.292h29.416v29.416H33.292V33.292z M66.708,62.708v-2.684h3.66v2.684 H66.708z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.05919645d73a4a94402ace754a378366.svg";
export { ForwardRef as ReactComponent };